import { useEffect, useState } from "react";
import { UserOnboardingData } from "./enum";
import Supademo from "./Supademo";
import { getData, handlePatch } from "./utils";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { getUserActivePlan } from "@helpers/profileHelper";
import { useLocation } from "react-router-dom";

const DemoTouchPoint = ({ module, className, isViewed = false, label }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIsViewed, setCurrentIsViewed] = useState(false);
  const { search: searchUrlParams, pathname } = useLocation();
  const country = new URLSearchParams(searchUrlParams).get("country");
  const type = new URLSearchParams(searchUrlParams).get("type");
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource") || country + "-" + type;

  const { supademoUrl, modalHeading, touchPointDescription, brief, pendoEnum } = UserOnboardingData.strip_touchpoints_details[module];

  useEffect(() => {
    const getStripTouchPointData = async () => {
      const data = await getData("strip_touchpoints_details");
      setCurrentIsViewed(isViewed ? isViewed : (data[module]?.isViewed ?? false));
    };
    getStripTouchPointData();
  }, [module]);

  const handleOpen = async () => {
    trademoTrackingEvents(trackingEventDictionary[pendoEnum], generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    setIsOpen(true);
    setCurrentIsViewed(true);
  };

  const handleClose = async () => {
    trademoTrackingEvents(trackingEventDictionary.onboardingCloseCameFromStrip, generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    setIsOpen(false);
    const data = await getData("strip_touchpoints_details");
    if (!data[module]?.isViewed) {
      handlePatch("strip_touchpoints", module);
    }
  };

  return (
    <>
      <div className={`tw-bg-demo_touch_point tw-flex tw-items-center tw-text-sm tw-underline tw-py-2 tw-px-3 tw-cursor-pointer tw-shrink-0 tw-rounded-l-xl tw-text-gray-900 tw-font-medium tw-h-9 tw-overflow-hidden tw-w-fit ${className}`} onClick={handleOpen}>
        <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#101828" className="tw-flex-shrink-0">
          <path d="m490-435 215.77-145L490-725v290ZM237.62-106.16q-29.93 4.24-53.73-14.15-23.81-18.38-27.43-48.31l-51.07-412.76q-3.62-29.93 14.65-53.81 18.27-23.89 48.19-27.12l42.54-4.46v303.69q0 62.93 44.69 107.62 44.69 44.69 107.62 44.69h369.69q-2.92 19-16.88 33.04-13.97 14.04-34.2 16.65l-444.07 54.92Zm125.46-184.61q-30.31 0-51.31-21-21-21-21-51.31v-424.61q0-30.31 21-51.31 21-21 51.31 21h424.61Q818-860 839-839q21 21 21 51.31v424.61q0 30.31-21 51.31-21 21-51.31 21H363.08Z" />
        </svg>

        <span className={`tw-whitespace-nowrap tw-text-sm tw-font-semibold tw-transition-all tw-duration-300 ${!currentIsViewed || !isViewed ? "tw-opacity-100 tw-max-w-xs tw-ps-1" : "tw-opacity-0 tw-max-w-0"}`}>{label ?? touchPointDescription}</span>
      </div>

      {isOpen && <Supademo type="modal" url={supademoUrl} modalHeading={modalHeading} description={brief} closeModal={handleClose} />}
    </>
  );
};

export default DemoTouchPoint;
